module.exports = __webpack_public_path__ + "img/icon-link.fbc07e1a.svg";